import React from 'react'
import { useQuery } from '@apollo/client'
import { COMPANIES, COMPANIES_MEMBER } from './operations'
import { Companies, CompaniesVariables, CompaniesFilterInput, UsersFilterInput } from '../../types'

const PAGE_LENGTH = 10
const MEMBERS_PAGE_LENGTH = 5

interface Props {
  filter?: CompaniesFilterInput
  page?: number
  pageLength?: number
  skip?: boolean
  membersFilterData?: UsersFilterInput
  membersPage?: number
  membersPageLength?: number
  skipMembers?: boolean
}

interface CompanyMemberProps {
  userId: string
  companyId?: string
}

export const useCompanyMember = ({ userId, companyId }: CompanyMemberProps) => {
  return useQuery<boolean>(COMPANIES_MEMBER, {
    variables: { userId, companyId },
  })
}

export const useCompanies = ({
  filter,
  page = 1,
  pageLength = PAGE_LENGTH,
  skip = false,
  membersFilterData,
  membersPage = 1,
  membersPageLength = MEMBERS_PAGE_LENGTH,
  skipMembers = true,
}: Props = {}) => {
  const queryVariables = React.useMemo(
    () => ({
      filterData: filter,
      pagination: {
        from: page * pageLength - pageLength,
        length: pageLength,
      },
      membersFilterData,
      membersPagination: {
        from: membersPage * membersPageLength - membersPageLength,
        length: membersPageLength,
      },
      skipMembers,
    }),
    [filter, page, pageLength]
  )

  return useQuery<Companies, CompaniesVariables>(COMPANIES, {
    variables: queryVariables,
    skip,
  })
}
